export default "__VITE_ASSET__B5FT8EWS__"